import { useEffect, useState } from "react";
import { toAbsoluteUrl } from "../../../utils/CommonHelper";
import "./logo.css";

import { useAuth } from "../../auth/components/AuthInit";

function Logo({ openfrom }) {
  const [logoSrc, setLogoSrc] = useState("");
  const { currentUser } = useAuth();
  const platform = localStorage.getItem("platform");
  const searchParams = new URLSearchParams(window.location.search);
  const isTelegram = searchParams.get("platform") === "telegram" || platform === "telegram";

  useEffect(() => {
    if(!isTelegram){
      const selectedTheme = localStorage.getItem("selectedTheme");
      const logoSrc =
        selectedTheme === "dark"
          ? toAbsoluteUrl(
              `/image/${process.env.REACT_APP_IMAGE_PATH}/2a.png?15641555`
            )
          : toAbsoluteUrl(
              `/image/${process.env.REACT_APP_IMAGE_PATH}/2.png?15641555`
            );
      setLogoSrc(logoSrc);
    }
  }, [isTelegram]);

  if (isTelegram && currentUser) {
      return (
        <div className="d-flex align-items-center justify-content-center">
          <a href="/" className="logo d-flex align-items-center">
             <div className="d-flex align-items-center" style={{ gap: '10px' }}>
                {currentUser.profilePic && (
                    <img 
                        src={currentUser.profilePic} 
                        alt="Profile" 
                        style={{ 
                            width: '40px', 
                            height: '40px', 
                            borderRadius: '50%',
                            objectFit: 'cover' 
                        }} 
                    />
                )}
                {currentUser.fullName && (
                    <span style={{ 
                        fontWeight: 'bold', 
                        fontSize: '16px',
                        color: "var(--body_color)"
                    }}>
                        {currentUser.fullName}
                    </span>
                )}
             </div>
          </a>
        </div>
      );
  }

  return (
    <div className="d-flex align-items-center justify-content-center">
      <a href="/" className="logo d-flex align-items-center">
        {openfrom === "login" ? (
          <img
            src={logoSrc}
            alt="Logo"
            style={{ width: "25vh", height: "10vh" }}
          />
        ) : (
          <img src={logoSrc} alt="Logo" style={{ maxHeight: "26px" }} />
        )}
      </a>
    </div>
  );
}

export default Logo;
